import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import ScrollToTop from './components/ScrollToTop'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const UserLayout = React.lazy(() => import('./layout/UserLayout'))
const HomeLayout = React.lazy(() => import('./layout/homeLayout'))
const LoginLayout = React.lazy(() => import('./layout/LoginLayout'))
const UiLayout = React.lazy(() => import('./layout/uiLayout'))

// Pages
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <ScrollToTop />
          <Routes>
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route path="/login/*" name="Home" element={<UserLayout />} />
            <Route path="/users/*" name="Home" element={<LoginLayout />} />
            <Route exact path="*" name="Home Page" element={<HomeLayout />} />
            <Route exact path="/ui-design/*" name="ui Page" element={<UiLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
